import { Field } from '@approvalmax/ui';
import styled from 'styled-components';

import { OrderCustomMod } from './MainInformation.types';

export const Row = styled.div`
    display: flex;
    margin-top: 20px;

    & > * {
        flex: 1;
    }

    & > :not(:first-child) {
        margin-left: 10px;
    }

    & > :not(:last-child) {
        margin-right: 10px;
    }
`;

export const FieldOrdered = styled(Field)<OrderCustomMod>`
    order: ${({ order }) => order};
`;
